import { useMemo } from 'react';
import { useBootstrapApiBase } from '../api';
import { creditUsageCostKeys, CreditUsageTitle } from '../constants';
import { CreditUsage, CreditUsageType } from '../definition';
import { roundNumber } from '../utils';

export function useCreditUsageItem(type: CreditUsageType): CreditUsage {
  const api = useBootstrapApiBase();
  return useMemo(() => {
    // A composite type has no key of its own and is summed from its parts;
    // rounded because 0.1 + 0.5 is 0.6000000000000001 in float.
    const credit = roundNumber(
      creditUsageCostKeys(type).reduce(
        (sum, key) => sum + (api.data?.cost[key] ?? 0),
        0
      ),
      2
    );

    return {
      credit,
      title: CreditUsageTitle[type],
      type,
    };
  }, [type, api.data?.cost]);
}
